import React from 'react';
import '../assets/css/mapSection.css';

const MapSection = () => {
    return (
        <section className="map-section">
            <div className="map-container">
                {/* Section Header */}
                <div className="section-header">
                    <span className="section-subtitle">OUR CLIENTS</span>
                    <h2 className="section-title">
                        Trusted by Thousand of <br /> People & Companies
                    </h2>
                </div>

                {/* Map Placeholder Container */}
                <div className="map-wrapper">
                    {/* Replace the src with your actual Google Maps Embed link */}
                    <iframe
                        title="Business Location"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d960635.7960766676!2d72.26972289425811!3d21.187738646132512!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be0d386a99f41ed%3A0xc99808f4689a7d4a!2sGIDC%20SARIGAM!5e0!3m2!1sen!2sin!4v1768136938407!5m2!1sen!2sin"
                        width="100%"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>

                    {/* Custom Overlay for 'View Larger Map' button as seen in screenshot */}
                    <div className="map-overlay-btn">
                        <a
                            href="https://maps.google.com"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            View larger map
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MapSection;